// import React, { Component, useState } from 'react';
import configData from '../../configData.json';
import SelectSearch, { fuzzySearch } from "react-select-search";

// export default function TopFilterData({ onChange, count }) { 

//     return (
//         <>
//             <div> 
//                 <div className='d-flex'>
//                     <div className="form-field me-2">
//                         <label>Criteria</label>
//                         <div>
//                             <select id="datalistOptions" className='form-select form-select-sm'>
//                                 <option value="">Customer</option>
//                                 <option value="">Transportation Provider</option>
//                                 <option value="">Freight Bill Number</option>
//                                 <option value="">Transportation Account Number</option>
//                                 <option value="">Entry Date</option>
//                             </select>
//                         </div>
//                     </div> 
//                     <div className="form-field">
//                         <label>Value</label>
//                         <div>
//                         <input className="form-control form-control-sm" type="text"></input> 
//                         </div>
//                     </div>
//                     {/* <button className='close-filter'><i class="fas fa-times"></i></button> */}
//                 </div>
//             </div>
//         </>

//     )
// }

import React, { Component, useState } from 'react';
import { useEffect } from 'react';

export default function SettingsTopFilterData({ onChange, filterkey, carrierData, customerData, criData, divisionData }) {
    const [values, setValues] = useState('');

    const [owners, setOwners] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [carrierLoading, isCarrierLoading] = useState(false);
    const [selectedCust, setSelectedCust] = useState(0);

    // const criData = [
    //     { criKey: 1, criValue: 'Customer' },
    //     { criKey: 2, criValue: 'Transportation Provider' },
    //     { criKey: 3, criValue: 'Freight Bill Number' },
    //     { criKey: 4, criValue: 'Transportation Provider Account Number' }
    // ];

    let handleDropdownChange = (e) => {
        //   console.log(e.target.value);
        // debugger;
        // if (customers.length > 0 &&  document.getElementById("datalistOptions").selectedIndex != 1) {
        //     alert('Customer is a Required Field, a selection must be made');
        //     document.getElementById("datalistOptions").selectedIndex = 0;
        //     return;
        // }
        setValues(e.target.value);
        var index = e.nativeEvent.target.selectedIndex;
        var text = e.nativeEvent.target[index].text;
        filterkey(text);
    }

    // const LoadCustomer = async () => {
    //     debugger;
    //     if (customers.length == 0) {
    //         isCarrierLoading(true);
    //         const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList`;
    //         await fetch(custUrl,
    //             {
    //                 method: 'GET',
    //                 headers: {
    //                     'Content-type': 'application/json',
    //                     'Authorization': sessionStorage.getItem('my-token')
    //                 }
    //             }
    //         ).then(resp => resp.json())
    //             .then(resp => setCustomers(resp))
    //         isCarrierLoading(false);
    //     }


    const LoadOwners = async () => {
        debugger;
        if (customers.length === 0) {
            isCarrierLoading(true);
            const custUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
            await fetch(custUrl, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
                .then(resp => resp.json())
                .then(resp => {
                    // Assuming `resp` is an array of owners retrieved from the API
                    // Set the loading state to false before modifying the owners array
                    isCarrierLoading(false);
                    // Create a placeholder for "-- ALL OWNERS"
                    const allOwnersPlaceholder = { ownerID: "0", ownerName: "--ALL OWNERS--" };
                    // Combine the placeholder with the retrieved owners and existing owners array
                    setOwners(existingOwners => {
                        const updatedOwners = [allOwnersPlaceholder, ...resp, ...existingOwners];
                        return updatedOwners;
                    });
                })
                .catch(error => {
                    console.error('Error fetching owners:', error);
                    isCarrierLoading(false);
                });
        }
    }




    useEffect(() => {
        LoadOwners();
    }, [])


    function createInputs() {
        return (
            <div >
                {(values == 4 || values == 5) ?
                    (
                        <input type="text" className="form-control form-control-sm" onChange={onChange} />
                    )
                    : (values == 1) ?
                        (

                            <select id="owner" className='form-select form-select-sm' onChange={onChange}>
                                <option value="-1">--Select A Value--</option>
                                {owners.map((data, index) => {
                                    return <option key={data.ownerID} value={data.ownerID}>{data.ownerName}</option>
                                })}
                            </select>

                        )
                        : (values == 2) ?
                            (
                                // <select id="customer" className='form-select form-select-sm' onChange={onChange}>
                                //                     <option value=" ">--Select--</option>
                                //                     <option value="C0">CAMERON</option>
                                //                     <option value="C1">HALLIBURTON NA</option>
                                //                     <option value="C2">HONEYWELL</option>
                                //                     <option value="C3">APPLIED MATERIALS</option>
                                //                     <option value="C4">NXP GLOBAL</option> <option value="">HALLIBURTON NA</option>
                                //                     <option value="C5">HONEYWELL</option>
                                //                     <option value="C6">APPLIED MATERIALS</option>
                                //                     <option value="C7">NXP GLOBAL</option>
                                //                 </select>

                                <select id="customer" className='form-select form-select-sm' onChange={onChange}>
                                    <option value="-1">--Select A Value--</option>
                                    {customerData.map((data, index) => {
                                        return <option key={data.customerKey} value={data.customerKey}>{data.customerName}</option>
                                    })}
                                </select>

                                // <SelectSearch
                                //     id="ddnCustomer"
                                //     name="ddnCustomer"
                                //     value={selectedCust}
                                //     options={customers}
                                //     onChange={onChange}
                                //     search
                                //     filterOptions={fuzzySearch}

                                // >
                                // </SelectSearch>
                            )
                            : (values == 3) ?
                                (
                                    // <select id="carr" className='form-select form-select-sm' onChange={onChange}>
                                    //     <option value="CA1">Fedex</option>
                                    //     <option value="CA2">UPS</option>
                                    //     <option value="CA3">EXPEDITORS INTERNATIONAL UNITED STATES</option>
                                    // </select>

                                    <select id="carr" className='form-select form-select-sm' onChange={onChange}>
                                        <option value="-1">--Select A Value--</option>
                                        {carrierData.map((data, index) => {
                                            return <option key={data.carrierKey} value={data.carrierKey}>{data.carrierName}</option>
                                        })}
                                    </select>

                                )
                                : (values == 6) ?
                                    (
                                        // <select id="carr" className='form-select form-select-sm' onChange={onChange}>
                                        //     <option value="CA1">Fedex</option>
                                        //     <option value="CA2">UPS</option>
                                        //     <option value="CA3">EXPEDITORS INTERNATIONAL UNITED STATES</option>
                                        // </select>

                                        <select id="divsn" className='form-select form-select-sm' onChange={onChange}>
                                            <option value="-1">--Select A Value--</option>
                                            {divisionData.map((data, index) => {
                                                return <option key={data.divisionKey} value={data.divisionKey}>{data.divisionName}</option>
                                            })}
                                        </select>

                                    ) : (<span></span>)
                }
            </div>
        )

    }
    return (
        <>
            <div>
                <div className='d-flex'>
                    <div className="form-field me-2">
                        <label>Criteria</label>
                        <div>
                            {/* <select id="datalistOptions" className='form-select form-select-sm' onChange={(e) => handleDropdownChange(e)}>
                                <option value="0">-Select-</option>
                                <option value="1">Customer</option>
                                <option value="2">Carrier</option>
                            </select> */}

                            <select id="datalistOptions" className='form-select form-select-sm' onChange={(e) => handleDropdownChange(e)}>
                                <option value="-1">--Select A Value--</option>
                                {criData.map((data, index) => {
                                    return <option key={data.criKey} value={data.criKey}>{data.criValue}</option>
                                })}
                            </select>

                        </div>
                    </div>
                    <div className="form-field">
                        <label>Value</label>
                        {createInputs()}
                    </div>
                </div>
            </div>
        </>

    )
}